
import { defineComponent, ref } from 'vue'
import { LocalStorage } from 'quasar'
import { isJSON } from '@/utils'

const CNAME = '__directr-dismissable'

export default defineComponent({
  props: {
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    dismissLabel: {
      type: String,
      default: 'dismiss'
    },
    icon: {
      type: String,
      default: 'information'
    }
  },
  setup (props) {
    const container = ref()
    const messages = ref<Record<string, any>>(LocalStorage.getItem(CNAME) || {})

    if (typeof (messages as any) === 'string') {
      LocalStorage.set(CNAME, isJSON(messages.value) ? JSON.parse(messages.value as any) : {})
      messages.value = LocalStorage.getItem(CNAME) || {}
    }
    const dismissed = messages.value[props.id]
    function dismiss ($event) {
      container.value.classList.add('dismiss')
      if (!props.id) {
        console.warn('Dismissable | Could not update dismissable cookie with dismissed message id, because no id prop was set')
        return
      }
      messages.value[props.id] = true
      LocalStorage.set(CNAME, messages.value)
    }

    return { container, dismiss, dismissed }
  }
})
